import { NoDataPage, CircularLoader } from "@components/index";
import { formatDate } from "@utils/index";
import { getStatusBadgeClass } from "../../claimsData";
import ClaimActionDropdown from "../ClaimActionDropdown";
import { tableColumns } from "./ClaimListRenderData";
import "./index.scss";

const ClaimListRender = ({
  claims,
  loading,
  error,
  onViewClaim,
  onActionClick,
  onClearFilters,
}) => {
  // Show loading state
  if (loading) {
    return (
      <div className="claim-list-render__loading">
        <CircularLoader
          message="Loading Claims Data ..."
          className="claim-list-render__loading-container"
        />
      </div>
    );
  }

  // Show table if we have claims
  if (claims && claims.length > 0 && !error) {
    return (
      <div className="claim-list-render">
        <div className="claim-list-render__table-container">
          <table className="claims-table">
            <thead>
              <tr>
                {tableColumns.map((column) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {claims.map((claim, key) => (
                <tr key={key}>
                  <td>
                    <strong>{claim.claim_id}</strong>
                  </td>
                  <td>
                    <strong>{claim.pnr_number}</strong>
                  </td>
                  <td>{claim.customer_mobile}</td>
                  <td>₹{claim.fare_amount}</td>
                  <td>{formatDate(claim.journey_date)}</td>
                  <td>{formatDate(claim.claim_initiation_datetime)}</td>
                  <td>
                    <span
                      className={`claims-table__status ${getStatusBadgeClass(
                        claim.claim_status,
                      )}`}
                    >
                      {claim.claim_status}
                    </span>
                  </td>
                  <td>
                    <div className="claims-table__actions">
                      <ClaimActionDropdown
                        claim={claim}
                        onActionClick={onActionClick}
                        isButtonClickable={claim.claim_status === "Pending"}
                      />
                    </div>
                  </td>

                  <td>
                    <button
                      className="claims-table__action-icon claims-table__action-icon--view"
                      onClick={() => onViewClaim(claim)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // Show no data state
  return (
    <div className="claim-list-render__no-data">
      <NoDataPage
        showRetryButton
        onButtonClick={onClearFilters}
        buttonText={error ? "Retry" : "Reset Filters"}
        message={error ? "Failed to load claims data" : "No claims found"}
      />
    </div>
  );
};

export default ClaimListRender;
